import { UserService } from '../services';
// import store from "../store";

const user = JSON.parse(localStorage.getItem("user-portal"));
const state = () => ({
  status: user ? { loggedIn: true } : { loggedIn: false },
  user: user || { lang: "fr" },
  email_verified: false
});
const getters = {
  isEmailVerified(state) {
    return state.email_verified;
  },
  userIsAdmin(state) {
    return state.user && state.user.admin;
  }
};

const actions = {
  reconnect() {
    UserService.reconnectAuth0User()
  },
  changeUserLang({ commit, state }, lang) {
    if (state.user._id) UserService.changeUserLanguage(state.user._id, lang);
    commit("changeUserLanguage", lang);
  },
  changeAccessibility({ commit, state }, accessibilityEnabled) {
    if (state.user._id) UserService.changeAccessibility(state.user._id, accessibilityEnabled);
    commit("changeAccessibility", accessibilityEnabled);
  },
  deleteUser(_, userId) {
    return UserService.deleteUser(userId)
      .then(
        async(data) => {
          if (data && data.deleteUser === null) {
            // deletion did not work
            throw new Error("Deletion returned null")
          }

          return data
        },
        (error) => {
          console.log("Error deleting user: ", error)
          throw error
        }
      )
  },
  logoutAfterDeletion({ commit }) {
    UserService.logoutAuth0User()
    commit("logout")
  },
  addAuth0User({ commit }, { userToSave, email_verified }) {
    localStorage.setItem("user-portal", JSON.stringify(userToSave))
    commit("loginSuccess", { user: userToSave, email_verified: email_verified })
  },
  logoutAuth0User({ commit } ) {
    UserService.logoutAuth0User()
    commit("logout")
  },
}


const mutations = {
  loginSuccess(state, { user, email_verified }) {
    state.status = { loggedIn: true }
    state.user = user
    state.email_verified = email_verified
  },
  loginFailure(state) {
    state.status = { loggedIn: false }
    state.user = { lang: "fr" }
    state.email_verified = false
  },
  logout(state) {
    state.status = { loggedIn: false }
    state.user = { lang: "fr" }
    state.email_verified = false
  },
  registering(state) {
    state.status = { registering: true }
  },
  clearStatus(state) {
    state.status = { loggedIn: false }
  },
  changeUserLanguage(state, lang) {
    state.user.lang = lang
  },
  changeAccessibility(state, accessibilityEnabled) {
    state.user.accessibilityEnabled = accessibilityEnabled
  }
}


export const account = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}